/* eslint-disable import/no-webpack-loader-syntax */
import React from "react";

//@ts-ignore
import css from "!raw-loader!./tourviewer.css";
// @ts-ignore
import buttonsCss from "!raw-loader!../common/buttons.css";

//GUI ELEMENTS
import TourViewerErrorPage from "./TourViewerErrorPage";
import TourViewerHeader from "./TourViewerHeader";
import TourViewerExperience from "./GL/TourViewerExperience.tsx";
import TourViewerPopup from "./TourViewerPopup";

import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { UseGetTour, useLocalizationFile } from "../../api/calls/Queries.ts";
import TourViewerLoading from "./TourViewerLoading.tsx";

function TourViewer(props: { tourID: number; userID: number }) {
  const {
    data: tourData,
    isLoading: loadingTour,
    isError,
    error,
  } = UseGetTour(props.tourID);

  // const { data } = UseAssetsQuery(props.tourID, 2);
  const { data: lang } = useLocalizationFile();

  // const [popupIsOpen, setPopupIsOpen] = useState<boolean>(false);
  // const [groupsPanel, setGroupsPanel] = useState<boolean>(false);

  const handle = useFullScreenHandle();

  return (
    <FullScreen handle={handle}>
      <div className="tour-viewer">
        <style>
          {buttonsCss}
          {css}
        </style>

        {isError && <TourViewerErrorPage err={error} />}
        {loadingTour && <TourViewerLoading />}

        {tourData && !loadingTour && (
          <>
            {!tourData.scenes ? (
              <div
                style={{
                  position: "absolute",
                  background: "#083344",
                  left: 0,
                  top: 0,
                  width: "100%",
                  height: "100%",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                }}
              >
                Tour vuoto da definire nell'editor
              </div>
            ) : (
              <>
                <TourViewerHeader tourData={tourData} />

                <TourViewerPopup
                  tourID={props.tourID}
                  userID={props.userID}
                  tourData={tourData}
                />

                <TourViewerExperience
                  tourData={tourData}
                  handle={handle}
                  tourID={props.tourID}
                />
              </>
            )}
          </>
        )}
      </div>
    </FullScreen>
  );
}

export default TourViewer;
